module.exports = __webpack_public_path__ + "static/media/AS.cc113fa6.jpg";